import { FC } from 'react';
import { ContactUsIcon, FAQIcon } from '../../../assets/icons';

const knowledgeBaseUrl = 'https://knowledge.cultwines.com';
interface HelpCenterProps {
  onChangeRequest: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}
const HelpCenter: FC<HelpCenterProps> = ({ onChangeRequest }) => {
  return (
    <div className="flex flex-wrap w-full h-full p-8 gap-6 justify-center bg-gray-50 dark:bg-slate-900">
      {[
        {
          title: 'Contact Us',
          icon: <ContactUsIcon className="w-20 h-20" />,
          gradient: 'from-vine to-vine/80 dark:from-slate-700 dark:to-slate-800',
          shadowColor: 'shadow-vine/30 dark:shadow-slate-900/50',
          description: 'Click here to contact us and speak to a member of our team',
          onClick: onChangeRequest,
        },
        {
          title: 'FAQ',
          icon: <FAQIcon className="w-20 h-20" />,
          gradient: 'from-orange to-orange/80 dark:from-teal-500 dark:to-teal-600',
          shadowColor: 'shadow-orange/30 dark:shadow-teal-500/30',
          description: 'Click here to see our frequently asked questions',
          onClick: () => window.open(knowledgeBaseUrl, '_blank'),
        },
      ].map((item, index) => {
        const { gradient, shadowColor, icon, title, description } = item;
        return (
          <div
            onClick={item.onClick}
            key={`help-${index}`}
            className={`flex flex-col p-8 cursor-pointer w-full sm:w-[320px] h-[360px] text-center items-center justify-center gap-6 rounded-2xl bg-gradient-to-br ${gradient} text-white shadow-xl ${shadowColor} hover:scale-105 hover:shadow-2xl transition-all duration-300`}
          >
            <h2 className="text-2xl font-bold">{title}</h2>
            <div className="opacity-90">{icon}</div>
            <p className="text-sm opacity-90 leading-relaxed max-w-[240px]">{description}</p>
            <div className="mt-2 px-6 py-2 rounded-full bg-white/20 text-sm font-medium hover:bg-white/30 transition-colors">
              Learn More →
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HelpCenter;
